import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="altcha"
export default class extends Controller {
  connect() {
    import("altcha");
  }
}
